import { faApple, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faTimesCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MDBCol, MDBRow } from 'mdbreact';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import {
  Card,
  Dataset,
  Chart,
  Button,
  Input,
  Modal,
} from 'react-rainbow-components';
import { Link, useHistory } from 'react-router-dom';
import CustomLoader from '../shared/Customloader';
import { customStyles } from '../shared/datatables/styles';
import ShowNotification from '../shared/Notification';
import { RequestInit, RequestInitWithBody } from '../shared/RequestInit';

export interface propsToEdit {
  Id: number;
  annee: string;
  apple_music: string;
  artiste: string;
  categorie: { Categorie_1: string; Categorie_2: string; Categorie_3: string };
  derniere_diffusion: string;
  priorite: number;
  titre: string;
  photo: string;
  votes: number;
  youtube: number | 0;
}

const FilterComponent = ({ filterText, onFilter, onClear }: any) => (
  <>
    <MDBRow className="mb-2 mt-4" center={true}>
      <MDBCol md="12" className="px-0">
        <Input
          id="search"
          type="text"
          placeholder="Rechercher"
          aria-label="Search Input"
          value={filterText}
          onChange={onFilter}
          onClick={onClear}
        />
      </MDBCol>
    </MDBRow>
  </>
);

const ListAllMusic = () => {
  const [Music, setMusic] = useState<[]>([]);
  const [filterText, setFilterText] = useState<string>('');
  const [pending, setPending] = useState<boolean>(false);
  const [resetPaginationToggle, setResetPaginationToggle] =
    useState<boolean>(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [todelete, setTodelete] = useState<number | undefined>(undefined);
  const [updated, setUpdated] = useState(false);
  const [errdeleted, setErrDeleted] = useState(false);
  const history = useHistory<any>();

  const filteredItems = Music.filter(
    (item: any) =>
      (item.artiste &&
        item.artiste.toUpperCase().includes(filterText.toUpperCase())) ||
      (item.titre &&
        item.titre.toUpperCase().includes(filterText.toUpperCase())) ||
      (item.annee &&
        item.annee.toUpperCase().includes(filterText.toUpperCase())) ||
      (item.categorie.categorie_1 &&
        item.categorie.categorie_1
          .toUpperCase()
          .includes(filterText.toUpperCase())) ||
      (item.votes && String(item.votes).includes(filterText))
  );
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText('');
    }
  };
  const fetchMusic = async () => {
    await fetch(
      'https://admin.radioemotion.be/api/music/getall',
      RequestInit as RequestInit
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.response === true) {
          console.log(response.data);
          setMusic(response.data);
          setPending(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setPending(false);
      });
  };
  useEffect(() => {
    setPending(true);
    fetchMusic();
  }, []);

  const deleteRow = async () => {
    const deleteMusic = async () => {
      await fetch(
        'https://admin.radioemotion.be/api/music/delete',
        RequestInitWithBody({
          body: { Id: todelete },
          type: 'DELETE',
        }) as RequestInit
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.response === true) {
            console.log(response.data);
            fetchMusic();
            setErrDeleted(false);
          } else {
            setErrDeleted(true);
          }
        })
        .catch((err) => {
          console.log(err);
          setErrDeleted(true);
        });
    };
    deleteMusic();
    setTodelete(undefined);
  };

  return (
    <>
      {updated ||
      (history.location.state && history.location.state.passed === true) ? (
        <ShowNotification
          icon="check"
          iconClassName="success-dark-text"
          bodyClassName="px-5 font-weight-bold text-white success-color-dark"
          autohide={5000}
          title=""
          message={'Mise à jour réussie'}
          text="maintenant"
        />
      ) : errdeleted ? (
        <ShowNotification
          icon="times"
          iconClassName="color-red"
          bodyClassName="color-red background-color-red text-white"
          autohide={5000}
          title=""
          message="Une erreur s'est produite"
          text="maintenant"
        />
      ) : null}
      <Modal
        id="confirmDelete"
        title="Voulez-vous vraiment supprimer ?"
        isOpen={showConfirm}
        onRequestClose={() => {
          setShowConfirm(!showConfirm);
          setTodelete(undefined);
        }}
      >
        <div className="d-flex justify-content-between mt-5">
          <Button
            variant="brand"
            label="Annuler"
            onClick={() => setShowConfirm(false)}
          />
          <Button
            variant="brand"
            label="Confirmer"
            onClick={() => {
              setShowConfirm(false);
              deleteRow();
            }}
          />
        </div>
      </Modal>
      <MDBRow>
        <MDBCol md="9" className="offset-2">
          <DataTable
            pointerOnHover={true}
            data={filteredItems}
            customStyles={customStyles}
            progressPending={pending}
            noHeader={true}
            progressComponent={<CustomLoader />}
            subHeader={true}
            subHeaderComponent={
              <FilterComponent
                onFilter={(e: any) => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
              />
            }
            pagination={true}
            className="datatable"
            columns={[
              {
                name: `Id`,
                selector: `Id`,
                sortable: true,
                width: '5%',
                cell: (row: propsToEdit) => (
                  <>
                    <Link
                      to={{ pathname: `/music/edit`, state: row }}
                      className="font-size-0dot65vw"
                    >
                      {row.Id}
                    </Link>
                  </>
                ),
              },
              {
                name: `Artiste`,
                selector: `artiste`,
                sortable: true,
                width: '22%',
                cell: (row) => (
                  <>
                    <Link to={{ pathname: `/music/edit`, state: row }}>
                      <p className="cut-text-1l font-size-0dot65vw">
                        {row.artiste}
                      </p>
                    </Link>
                  </>
                ),
              },
              {
                name: `Titre`,
                selector: `titre`,
                sortable: true,
                width: '22%',
                cell: (row) => (
                  <>
                    <Link to={{ pathname: `/music/edit`, state: row }}>
                      <p className="cut-text-1l font-size-0dot65vw">
                        {row.titre}
                      </p>
                    </Link>
                  </>
                ),
              },
              {
                name: `Année`,
                selector: `annee`,
                sortable: true,
                width: '6.5%',
                cell: (row) => (
                  <>
                    <Link
                      to={{ pathname: `/music/edit`, state: row }}
                      className="font-size-0dot65vw"
                    >
                      {row.annee}
                    </Link>
                  </>
                ),
              },
              {
                name: `Diffusion`,
                selector: `derniere_diffusion`,
                sortable: true,
                width: '8%',
                cell: (row) => (
                  <>
                    <Link
                      to={{ pathname: `/music/edit`, state: row }}
                      className="font-size-0dot65vw"
                    >
                      {row.derniere_diffusion}
                    </Link>
                  </>
                ),
              },
              {
                name: `Cat`,
                selector: `categorie`,
                sortable: true,
                width: '7.5%',
                cell: (row) => (
                  <>
                    <Link
                      to={{ pathname: `/music/edit`, state: row }}
                      className="font-size-0dot65vw"
                    >
                      {row.categorie.Categorie_2 !== null &&
                      row.categorie.Categorie_2.length > 10
                        ? row.categorie.Categorie_2.slice(2)
                        : row.categorie.Categorie_2}
                    </Link>
                  </>
                ),
              },
              {
                name: `Prio`,
                selector: `priorité`,
                sortable: true,
                width: '4.5%',
                cell: (row) => (
                  <>
                    <Link
                      to={{ pathname: `/music/edit`, state: row }}
                      className="text-center w-100 font-size-0dot65vw"
                    >
                      <p>{row.priorite}</p>
                    </Link>
                  </>
                ),
              },
              {
                name: `votes`,
                selector: `votes`,
                sortable: true,
                width: '5.5%',
                cell: (row) => (
                  <>
                    <Link
                      to={{ pathname: `/music/edit`, state: row }}
                      className="text-center w-100 font-size-0dot65vw"
                    >
                      <p>{row.votes}</p>
                    </Link>
                  </>
                ),
              },
              {
                name: ``,
                selector: `photo`,
                width: '6%',
                cell: (row) => (
                  <>
                    <Link to={{ pathname: `/`, state: { row } }}>
                      <Card className="my-2">
                        {' '}
                        <img
                          className="rounded w-100"
                          alt={row.photo}
                          src={row.photo}
                        />
                      </Card>
                    </Link>
                  </>
                ),
              },
              {
                name: ``,
                selector: `apple_music`,
                width: '4%',
                cell: (row) => (
                  <>
                    {' '}
                    {row.apple_music === '0' ? (
                      <></>
                    ) : (
                      <>
                        <a target="_blanc" href={`${row.apple_music}`}>
                          <FontAwesomeIcon
                            icon={faApple}
                            className="font-size-1dot1vw"
                          />
                        </a>
                      </>
                    )}
                  </>
                ),
              },
              {
                name: ``,
                selector: `youtube`,
                width: '5%',
                cell: (row) => (
                  <>
                    {' '}
                    {row.youtube === 0 ? (
                      <></>
                    ) : (
                      <a
                        href={`${row.youtube !== 0 ? row.youtube : null}`}
                        target="_blanc"
                      >
                        <FontAwesomeIcon
                          icon={faYoutube}
                          className="font-size-1dot1vw color-red"
                        />
                      </a>
                    )}
                  </>
                ),
              },
              {
                name: ``,
                selector: `delete`,
                width: '4%',
                cell: (row) => (
                  <>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      onClick={() => {
                        setShowConfirm(true);
                        setTodelete(row.Id);
                      }}
                      className="font-size-0dot9vw mx-auto"
                    ></FontAwesomeIcon>
                  </>
                ),
              },
            ]}
          ></DataTable>
        </MDBCol>
      </MDBRow>
    </>
  );
};

export default ListAllMusic;
